import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { Form, Button, Alert } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'

import { renderField } from 'core/utils/form'

const propTypes = {
  onSubmit: PropTypes.func.isRequired
}

const validate = values => {
  const errors = {}
  if (!values.email) { errors.email = 'Required' }
  if (!values.password) { errors.password = 'Required' }
  return errors
}

class LoginForm extends Component {

  render() {
    const { error, handleSubmit, invalid, submitting } = this.props

    return (
      <Form onSubmit={handleSubmit} noValidate>

        {error && (<Alert color="danger">{error}</Alert>)}

        <Field
          name="email"
          error={error}
          component={renderField}
          type="email"
          placeholder="Email"
        />

        <Field
          name="password"
          error={error}
          component={renderField}
          type="password"
          placeholder="Password"
        />

        <Button
          color="success"
          disabled={invalid || submitting}
        >Login</Button>
      </Form>
    )
  }
}

LoginForm.propTypes = propTypes

LoginForm = reduxForm({
  form: 'login',
  validate
})(LoginForm)

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/layouts/login/LoginForm/index.js